import * as React from 'react';
import { Trend } from '@shapeable/types';

export const TrendsExplorerContext = React.createContext<Trend[]>(null);
export const TrendsExplorerProvider = TrendsExplorerContext.Provider;